import { assign, timeStampNow } from '@datadog/browser-core';
import { RecordType } from '../../types';
export function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
export function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
export function assembleIncrementalSnapshot(source, data) {
    return {
        data: assign({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: timeStampNow(),
    };
}
//# sourceMappingURL=utils.js.map